import type { ILink } from "@components/core/Link";

export const isValidLink = (link?: ILink) => !!(link && link?.href);

export const isValidLinkWithLabel = (link?: ILink) => !!(link && link?.href && link?.label);
